var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // TODO: разбить functions.js

        // todo: mobile only logic, remove from common
        if (typeof app !== 'undefined' && typeof app.isMobile !== 'undefined' && app.isMobile) {
            $(window).on('load', function () {
                var $callBackButton = $('#layoutBottomBtn');

                // вызываем форму коллбека при нажатии на кнопку "Подберите мне тур"
                var $pickUpTourButton = $('.btn-pick-up-tour-for-me');
                $pickUpTourButton.on('click', function (e) {
                    window.brxTracking.sendAnalyticsEvent('callback_request_sent_mobile');
                    e.preventDefault();
                    window.openMainCallback('pickUpTourForMe', { formTypeName: 'pickUpTourForMe' });
                    window.toggleMainCallbackFormModeList(false);
                });

                $('.w-clbk-type-show-write-back-form-for-whatsapp').on('click', function (e) {
                    e.preventDefault();
                    window.openMainCallback('writeBackOnWhatsapp', { formTypeName: 'writeBackOnWhatsapp' });
                    window.toggleMainCallbackFormModeList(false);
                });

                $('.js-whatsapp-request').on('click', function (e) {
                    e.preventDefault();
                    window.brxTracking.sendAnalyticsEvent('write_whatsapp_mobile', {
                        'Is callback form': true
                    });
                    window.openMainCallback('writeOnWhatsappFastRequest', { formTypeName: 'writeOnWhatsappFastRequest' });
                    window.toggleMainCallbackFormModeList(false);
                });

                // Авто открытие bottom sheet контактов при входе на сайт
                if (typeof $.cookie === 'function' && typeof $.cookie !== 'undefined' && (window.brxUtils.isLocalStorageSupported && localStorage.getItem('isShowSelectCityWidget') || app.city.id) && !$.cookie('mobile-callback-popup') && $callBackButton.length > 0
                // по умолчанию: включено - если явно не отключено, значит включено
                && $callBackButton.data('auto-open') !== 0) {
                    setTimeout(function () {
                        $callBackButton.trigger('click', [true]);
                        $.cookie('mobile-callback-popup', true, {
                            expires: 30,
                            path: '/'
                        });
                    }, 7000);
                }
            });
        }
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // Vanilla JS Only!
        var onDOMContentLoaded = function onDOMContentLoaded() {
            // При попадании блока в область видимости, загрузить картинку|установить фон
            var lazyBackgroundClass = 'lazy-img-bg-watch';
            // При попадании img в область видимости, загрузить картинку
            var lazyImageClass = 'lazy-img-watch';

            var lazyBackgrounds = [].slice.call(document.querySelectorAll('.' + lazyBackgroundClass));
            if ('IntersectionObserver' in window && lazyBackgrounds.length) {
                /**
                 * @param {IntersectionObserverEntry[]} entries
                 * @param {IntersectionObserver} observer
                 */
                var lazyBackgroundObserverCallback = function lazyBackgroundObserverCallback(entries, observer) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            // lazy backgroundImage
                            entry.target.style.backgroundImage = "url(" + entry.target.dataset.src + ")";
                            entry.target.classList.remove(lazyBackgroundClass);
                            observer.unobserve(entry.target);
                        }
                    });
                };
                var lazyBackgroundObserver = new IntersectionObserver(lazyBackgroundObserverCallback);
                var registerObserverEntries = function registerObserverEntries() {
                    lazyBackgrounds.forEach(function (lazyBackground) {
                        lazyBackgroundObserver.observe(lazyBackground);
                    });
                };
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(registerObserverEntries);
                } else {
                    registerObserverEntries();
                }
            }

            var lazyImages = [].slice.call(document.querySelectorAll('img.' + lazyImageClass));
            if (lazyImages.length) {
                var active = false;
                var lazyLoad = function lazyLoad() {
                    if (active === false) {
                        active = true;

                        setTimeout(function () {
                            lazyImages.forEach(function (lazyImage) {
                                if (lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0 && getComputedStyle(lazyImage).display !== 'none') {
                                    if (lazyImage.offsetParent) {
                                        lazyImage.src = lazyImage.dataset.src;
                                        lazyImage.classList.remove(lazyImageClass);
                                        lazyImage.dataset.loaded = '1';
                                    }
                                }
                            });

                            lazyImages = lazyImages.filter(function (image) {
                                return image.dataset.loaded !== '1';
                            });

                            if (lazyImages.length === 0) {
                                document.removeEventListener('scroll', lazyLoad);
                                window.removeEventListener('resize', lazyLoad);
                                window.removeEventListener('orientationchange', lazyLoad);
                            }

                            active = false;
                        }, 200);
                    }
                };

                document.addEventListener('scroll', lazyLoad);
                window.addEventListener('resize', lazyLoad);
                window.addEventListener('orientationchange', lazyLoad);
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(lazyLoad);
                } else {
                    lazyLoad();
                }

                document.querySelectorAll('.mpopup .mpopup_content').forEach(function (modal) {
                    modal.addEventListener('scroll', lazyLoad);
                });
            }

            document.removeEventListener('DOMContentLoaded', onDOMContentLoaded);
        };
        document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

        window.brxLazyImage = {
            /**
             * @param {HTMLImageElement|Element} lazyImgOrBg
             * @param {boolean} isImg
             */
            load: function load(lazyImgOrBg, isImg) {
                if (isImg) {
                    lazyImgOrBg.src = lazyImgOrBg.dataset.src;
                    lazyImgOrBg.classList.remove('lazy-img');
                    lazyImgOrBg.removeAttribute('data-src');
                } else {
                    lazyImgOrBg.style.backgroundImage = "url(" + lazyImgOrBg.dataset.src + ")";
                    lazyImgOrBg.classList.remove('lazy-img-bg');
                    lazyImgOrBg.removeAttribute('data-src');
                }
            },
            /**
             * @param {Element} parentElem
             * @param {boolean} img  Загрузить img
             * @param {boolean} background Загрузить bg
             */
            loadChildren: function loadChildren(parentElem) {
                var img = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var background = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                if (!parentElem) {
                    return;
                }
                if (img) {
                    parentElem.querySelectorAll('img.lazy-img').forEach(function (lazyImage) {
                        window.brxLazyImage.load(lazyImage, true);
                    });
                }
                if (background) {
                    parentElem.querySelectorAll('.lazy-img-bg').forEach(function (lazyImageBg) {
                        window.brxLazyImage.load(lazyImageBg, false);
                    });
                }
            }
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * Copyright 2016 Google Inc. All Rights Reserved.
         *
         * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
         *
         *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
         *
         */
        (function () {
            'use strict';

            // Exit early if we're not running in a browser.

            if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
                return;
            }

            // Exit early if all IntersectionObserver and IntersectionObserverEntry
            // features are natively supported.
            if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

                // Minimal polyfill for Edge 15's lack of `isIntersecting`
                // See: https://github.com/w3c/IntersectionObserver/issues/211
                if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
                    Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
                        get: function get() {
                            return this.intersectionRatio > 0;
                        }
                    });
                }
                return;
            }

            /**
             * Returns the embedding frame element, if any.
             * @param {!Document} doc
             * @return {!Element}
             */
            function getFrameElement(doc) {
                try {
                    return doc.defaultView && doc.defaultView.frameElement || null;
                } catch (e) {
                    // Ignore the error.
                    return null;
                }
            }

            /**
             * A local reference to the root document.
             */
            var document = function (startDoc) {
                var doc = startDoc;
                var frame = getFrameElement(doc);
                while (frame) {
                    doc = frame.ownerDocument;
                    frame = getFrameElement(doc);
                }
                return doc;
            }(window.document);

            /**
             * An IntersectionObserver registry. This registry exists to hold a strong
             * reference to IntersectionObserver instances currently observing a target
             * element. Without this registry, instances without another reference may be
             * garbage collected.
             */
            var registry = [];

            /**
             * The signal updater for cross-origin intersection. When not null, it means
             * that the polyfill is configured to work in a cross-origin mode.
             * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
             */
            var crossOriginUpdater = null;

            /**
             * The current cross-origin intersection. Only used in the cross-origin mode.
             * @type {DOMRect|ClientRect}
             */
            var crossOriginRect = null;

            /**
             * Creates the global IntersectionObserverEntry constructor.
             * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
             * @param {Object} entry A dictionary of instance properties.
             * @constructor
             */
            function IntersectionObserverEntry(entry) {
                this.time = entry.time;
                this.target = entry.target;
                this.rootBounds = ensureDOMRect(entry.rootBounds);
                this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
                this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
                this.isIntersecting = !!entry.intersectionRect;

                // Calculates the intersection ratio.
                var targetRect = this.boundingClientRect;
                var targetArea = targetRect.width * targetRect.height;
                var intersectionRect = this.intersectionRect;
                var intersectionArea = intersectionRect.width * intersectionRect.height;

                // Sets intersection ratio.
                if (targetArea) {
                    // Round the intersection ratio to avoid floating point math issues:
                    // https://github.com/w3c/IntersectionObserver/issues/324
                    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
                } else {
                    // If area is zero and is intersecting, sets to 1, otherwise to 0
                    this.intersectionRatio = this.isIntersecting ? 1 : 0;
                }
            }

            /**
             * Creates the global IntersectionObserver constructor.
             * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
             * @param {Function} callback The function to be invoked after intersection
             *     changes have queued. The function is not invoked if the queue has
             *     been emptied by calling the `takeRecords` method.
             * @param {Object=} opt_options Optional configuration options.
             * @constructor
             */
            function IntersectionObserver(callback, opt_options) {

                var options = opt_options || {};

                if (typeof callback != 'function') {
                    throw new Error('callback must be a function');
                }

                if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) {
                    throw new Error('root must be a Document or Element');
                }

                // Binds and throttles `this._checkForIntersections`.
                this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

                // Private properties.
                this._callback = callback;
                this._observationTargets = [];
                this._queuedEntries = [];
                this._rootMarginValues = this._parseRootMargin(options.rootMargin);

                // Public properties.
                this.thresholds = this._initThresholds(options.threshold);
                this.root = options.root || null;
                this.rootMargin = this._rootMarginValues.map(function (margin) {
                    return margin.value + margin.unit;
                }).join(' ');

                /** @private @const {!Array<!Document>} */
                this._monitoringDocuments = [];
                /** @private @const {!Array<function()>} */
                this._monitoringUnsubscribes = [];
            }

            /**
             * The minimum interval within which the document will be checked for
             * intersection changes.
             */
            IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

            /**
             * The frequency in which the polyfill polls for intersection changes.
             * this can be updated on a per instance basis and must be set prior to
             * calling `observe` on the first target.
             */
            IntersectionObserver.prototype.POLL_INTERVAL = null;

            /**
             * Use a mutation observer on the root element
             * to detect intersection changes.
             */
            IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

            /**
             * Sets up the polyfill in the cross-origin mode. The result is the
             * updater function that accepts two arguments: `boundingClientRect` and
             * `intersectionRect` - just as these fields would be available to the
             * parent via `IntersectionObserverEntry`. This function should be called
             * each time the iframe receives intersection information from the parent
             * window, e.g. via messaging.
             * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
             */
            IntersectionObserver._setupCrossOriginUpdater = function () {
                if (!crossOriginUpdater) {
                    /**
                     * @param {DOMRect|ClientRect} boundingClientRect
                     * @param {DOMRect|ClientRect} intersectionRect
                     */
                    crossOriginUpdater = function crossOriginUpdater(boundingClientRect, intersectionRect) {
                        if (!boundingClientRect || !intersectionRect) {
                            crossOriginRect = getEmptyRect();
                        } else {
                            crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
                        }
                        registry.forEach(function (observer) {
                            observer._checkForIntersections();
                        });
                    };
                }
                return crossOriginUpdater;
            };

            /**
             * Resets the cross-origin mode.
             */
            IntersectionObserver._resetCrossOriginUpdater = function () {
                crossOriginUpdater = null;
                crossOriginRect = null;
            };

            /**
             * Starts observing a target element for intersection changes based on
             * the thresholds values.
             * @param {Element} target The DOM element to observe.
             */
            IntersectionObserver.prototype.observe = function (target) {
                var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
                    return item.element == target;
                });

                if (isTargetAlreadyObserved) {
                    return;
                }

                if (!(target && target.nodeType == 1)) {
                    throw new Error('target must be an Element');
                }

                this._registerInstance();
                this._observationTargets.push({ element: target, entry: null });
                this._monitorIntersections(target.ownerDocument);
                this._checkForIntersections();
            };

            /**
             * Stops observing a target element for intersection changes.
             * @param {Element} target The DOM element to observe.
             */
            IntersectionObserver.prototype.unobserve = function (target) {
                this._observationTargets = this._observationTargets.filter(function (item) {
                    return item.element != target;
                });
                this._unmonitorIntersections(target.ownerDocument);
                if (this._observationTargets.length == 0) {
                    this._unregisterInstance();
                }
            };

            /**
             * Stops observing all target elements for intersection changes.
             */
            IntersectionObserver.prototype.disconnect = function () {
                this._observationTargets = [];
                this._unmonitorAllIntersections();
                this._unregisterInstance();
            };

            /**
             * Returns any queue entries that have not yet been reported to the
             * callback and clears the queue. This can be used in conjunction with the
             * callback to obtain the absolute most up-to-date intersection information.
             * @return {Array} The currently queued entries.
             */
            IntersectionObserver.prototype.takeRecords = function () {
                var records = this._queuedEntries.slice();
                this._queuedEntries = [];
                return records;
            };

            /**
             * Accepts the threshold value from the user configuration object and
             * returns a sorted array of unique threshold values. If a value is not
             * between 0 and 1 and error is thrown.
             * @private
             * @param {Array|number=} opt_threshold An optional threshold value or
             *     a list of threshold values, defaulting to [0].
             * @return {Array} A sorted list of unique and valid threshold values.
             */
            IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
                var threshold = opt_threshold || [0];
                if (!Array.isArray(threshold)) threshold = [threshold];

                return threshold.sort().filter(function (t, i, a) {
                    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
                        throw new Error('threshold must be a number between 0 and 1 inclusively');
                    }
                    return t !== a[i - 1];
                });
            };

            /**
             * Accepts the rootMargin value from the user configuration object
             * and returns an array of the four margin values as an object containing
             * the value and unit properties. If any of the values are not properly
             * formatted or use a unit other than px or %, and error is thrown.
             * @private
             * @param {string=} opt_rootMargin An optional rootMargin value,
             *     defaulting to '0px'.
             * @return {Array<Object>} An array of margin objects with the keys
             *     value and unit.
             */
            IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
                var marginString = opt_rootMargin || '0px';
                var margins = marginString.split(/\s+/).map(function (margin) {
                    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
                    if (!parts) {
                        throw new Error('rootMargin must be specified in pixels or percent');
                    }
                    return { value: parseFloat(parts[1]), unit: parts[2] };
                });

                // Handles shorthand.
                margins[1] = margins[1] || margins[0];
                margins[2] = margins[2] || margins[0];
                margins[3] = margins[3] || margins[1];

                return margins;
            };

            /**
             * Starts polling for intersection changes if the polling is not already
             * happening, and if the page's visibility state is visible.
             * @param {!Document} doc
             * @private
             */
            IntersectionObserver.prototype._monitorIntersections = function (doc) {
                var win = doc.defaultView;
                if (!win) {
                    // Already destroyed.
                    return;
                }
                if (this._monitoringDocuments.indexOf(doc) != -1) {
                    // Already monitoring.
                    return;
                }

                // Private state for monitoring.
                var callback = this._checkForIntersections;
                var monitoringInterval = null;
                var domObserver = null;

                // If a poll interval is set, use polling instead of listening to
                // resize and scroll events or DOM mutations.
                if (this.POLL_INTERVAL) {
                    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
                } else {
                    addEvent(win, 'resize', callback, true);
                    addEvent(doc, 'scroll', callback, true);
                    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
                        domObserver = new win.MutationObserver(callback);
                        domObserver.observe(doc, {
                            attributes: true,
                            childList: true,
                            characterData: true,
                            subtree: true
                        });
                    }
                }

                this._monitoringDocuments.push(doc);
                this._monitoringUnsubscribes.push(function () {
                    // Get the window object again. When a friendly iframe is destroyed, it
                    // will be null.
                    var win = doc.defaultView;

                    if (win) {
                        if (monitoringInterval) {
                            win.clearInterval(monitoringInterval);
                        }
                        removeEvent(win, 'resize', callback, true);
                    }

                    removeEvent(doc, 'scroll', callback, true);
                    if (domObserver) {
                        domObserver.disconnect();
                    }
                });

                // Also monitor the parent.
                var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
                if (doc != rootDoc) {
                    var frame = getFrameElement(doc);
                    if (frame) {
                        this._monitorIntersections(frame.ownerDocument);
                    }
                }
            };

            /**
             * Stops polling for intersection changes.
             * @param {!Document} doc
             * @private
             */
            IntersectionObserver.prototype._unmonitorIntersections = function (doc) {
                var index = this._monitoringDocuments.indexOf(doc);
                if (index == -1) {
                    return;
                }

                var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;

                // Check if any dependent targets are still remaining.
                var hasDependentTargets = this._observationTargets.some(function (item) {
                    var itemDoc = item.element.ownerDocument;
                    // Target is in this context.
                    if (itemDoc == doc) {
                        return true;
                    }
                    // Target is nested in this context.
                    while (itemDoc && itemDoc != rootDoc) {
                        var frame = getFrameElement(itemDoc);
                        itemDoc = frame && frame.ownerDocument;
                        if (itemDoc == doc) {
                            return true;
                        }
                    }
                    return false;
                });
                if (hasDependentTargets) {
                    return;
                }

                // Unsubscribe.
                var unsubscribe = this._monitoringUnsubscribes[index];
                this._monitoringDocuments.splice(index, 1);
                this._monitoringUnsubscribes.splice(index, 1);
                unsubscribe();

                // Also unmonitor the parent.
                if (doc != rootDoc) {
                    var frame = getFrameElement(doc);
                    if (frame) {
                        this._unmonitorIntersections(frame.ownerDocument);
                    }
                }
            };

            /**
             * Stops polling for intersection changes.
             * @param {!Document} doc
             * @private
             */
            IntersectionObserver.prototype._unmonitorAllIntersections = function () {
                var unsubscribes = this._monitoringUnsubscribes.slice(0);
                this._monitoringDocuments.length = 0;
                this._monitoringUnsubscribes.length = 0;
                for (var i = 0; i < unsubscribes.length; i++) {
                    unsubscribes[i]();
                }
            };

            /**
             * Scans each observation target for intersection changes and adds them
             * to the internal entries queue. If new entries are found, it
             * schedules the callback to be invoked.
             * @private
             */
            IntersectionObserver.prototype._checkForIntersections = function () {
                if (!this.root && crossOriginUpdater && !crossOriginRect) {
                    // Cross origin monitoring, but no initial data available yet.
                    return;
                }

                var rootIsInDom = this._rootIsInDom();
                var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

                this._observationTargets.forEach(function (item) {
                    var target = item.element;
                    var targetRect = getBoundingClientRect(target);
                    var rootContainsTarget = this._rootContainsTarget(target);
                    var oldEntry = item.entry;
                    var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);

                    var rootBounds = null;
                    if (!this._rootContainsTarget(target)) {
                        rootBounds = getEmptyRect();
                    } else if (!crossOriginUpdater || this.root) {
                        rootBounds = rootRect;
                    }

                    var newEntry = item.entry = new IntersectionObserverEntry({
                        time: now(),
                        target: target,
                        boundingClientRect: targetRect,
                        rootBounds: rootBounds,
                        intersectionRect: intersectionRect
                    });

                    if (!oldEntry) {
                        this._queuedEntries.push(newEntry);
                    } else if (rootIsInDom && rootContainsTarget) {
                        // If the new entry intersection ratio has crossed any of the
                        // thresholds, add a new entry.
                        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
                            this._queuedEntries.push(newEntry);
                        }
                    } else {
                        // If the root is not in the DOM or target is not contained within
                        // root but the previous entry for this target had an intersection,
                        // add a new record indicating removal.
                        if (oldEntry && oldEntry.isIntersecting) {
                            this._queuedEntries.push(newEntry);
                        }
                    }
                }, this);

                if (this._queuedEntries.length) {
                    this._callback(this.takeRecords(), this);
                }
            };

            /**
             * Accepts a target and root rect computes the intersection between then
             * following the algorithm in the spec.
             * TODO(philipwalton): at this time clip-path is not considered.
             * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
             * @param {Element} target The target DOM element
             * @param {Object} targetRect The bounding rect of the target.
             * @param {Object} rootRect The bounding rect of the root after being
             *     expanded by the rootMargin value.
             * @return {?Object} The final intersection rect object or undefined if no
             *     intersection is found.
             * @private
             */
            IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, targetRect, rootRect) {
                // If the element isn't displayed, an intersection can't happen.
                if (window.getComputedStyle(target).display == 'none') return;

                var intersectionRect = targetRect;
                var parent = getParentNode(target);
                var atRoot = false;

                while (!atRoot && parent) {
                    var parentRect = null;
                    var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

                    // If the parent isn't displayed, an intersection can't happen.
                    if (parentComputedStyle.display == 'none') return null;

                    if (parent == this.root || parent.nodeType == /* DOCUMENT */9) {
                        atRoot = true;
                        if (parent == this.root || parent == document) {
                            if (crossOriginUpdater && !this.root) {
                                if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
                                    // A 0-size cross-origin intersection means no-intersection.
                                    parent = null;
                                    parentRect = null;
                                    intersectionRect = null;
                                } else {
                                    parentRect = crossOriginRect;
                                }
                            } else {
                                parentRect = rootRect;
                            }
                        } else {
                            // Check if there's a frame that can be navigated to.
                            var frame = getParentNode(parent);
                            var frameRect = frame && getBoundingClientRect(frame);
                            var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
                            if (frameRect && frameIntersect) {
                                parent = frame;
                                parentRect = convertFromParentRect(frameRect, frameIntersect);
                            } else {
                                parent = null;
                                intersectionRect = null;
                            }
                        }
                    } else {
                        // If the element has a non-visible overflow, and it's not the <body>
                        // or <html> element, update the intersection rect.
                        // Note: <body> and <html> cannot be clipped to a rect that's not also
                        // the document rect, so no need to compute a new intersection.
                        var doc = parent.ownerDocument;
                        if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != 'visible') {
                            parentRect = getBoundingClientRect(parent);
                        }
                    }

                    // If either of the above conditionals set a new parentRect,
                    // calculate new intersection data.
                    if (parentRect) {
                        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
                    }
                    if (!intersectionRect) break;
                    parent = parent && getParentNode(parent);
                }
                return intersectionRect;
            };

            /**
             * Returns the root rect after being expanded by the rootMargin value.
             * @return {ClientRect} The expanded root rect.
             * @private
             */
            IntersectionObserver.prototype._getRootRect = function () {
                var rootRect;
                if (this.root && !isDoc(this.root)) {
                    rootRect = getBoundingClientRect(this.root);
                } else {
                    // Use <html>/<body> instead of window since scroll bars affect size.
                    var doc = isDoc(this.root) ? this.root : document;
                    var html = doc.documentElement;
                    var body = doc.body;
                    rootRect = {
                        top: 0,
                        left: 0,
                        right: html.clientWidth || body.clientWidth,
                        width: html.clientWidth || body.clientWidth,
                        bottom: html.clientHeight || body.clientHeight,
                        height: html.clientHeight || body.clientHeight
                    };
                }
                return this._expandRectByRootMargin(rootRect);
            };

            /**
             * Accepts a rect and expands it by the rootMargin value.
             * @param {DOMRect|ClientRect} rect The rect object to expand.
             * @return {ClientRect} The expanded rect.
             * @private
             */
            IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
                var margins = this._rootMarginValues.map(function (margin, i) {
                    return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
                });
                var newRect = {
                    top: rect.top - margins[0],
                    right: rect.right + margins[1],
                    bottom: rect.bottom + margins[2],
                    left: rect.left - margins[3]
                };
                newRect.width = newRect.right - newRect.left;
                newRect.height = newRect.bottom - newRect.top;

                return newRect;
            };

            /**
             * Accepts an old and new entry and returns true if at least one of the
             * threshold values has been crossed.
             * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
             *    particular target element or null if no previous entry exists.
             * @param {IntersectionObserverEntry} newEntry The current entry for a
             *    particular target element.
             * @return {boolean} Returns true if a any threshold has been crossed.
             * @private
             */
            IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {

                // To make comparing easier, an entry that has a ratio of 0
                // but does not actually intersect is given a value of -1
                var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
                var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;

                // Ignore unchanged ratios
                if (oldRatio === newRatio) return;

                for (var i = 0; i < this.thresholds.length; i++) {
                    var threshold = this.thresholds[i];

                    // Return true if an entry matches a threshold or if the new ratio
                    // and the old ratio are on the opposite sides of a threshold.
                    if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
                        return true;
                    }
                }
            };

            /**
             * Returns whether or not the root element is an element and is in the DOM.
             * @return {boolean} True if the root element is an element and is in the DOM.
             * @private
             */
            IntersectionObserver.prototype._rootIsInDom = function () {
                return !this.root || containsDeep(document, this.root);
            };

            /**
             * Returns whether or not the target element is a child of root.
             * @param {Element} target The target element to check.
             * @return {boolean} True if the target element is a child of root.
             * @private
             */
            IntersectionObserver.prototype._rootContainsTarget = function (target) {
                var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
                return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
            };

            /**
             * Adds the instance to the global IntersectionObserver registry if it isn't
             * already present.
             * @private
             */
            IntersectionObserver.prototype._registerInstance = function () {
                if (registry.indexOf(this) < 0) {
                    registry.push(this);
                }
            };

            /**
             * Removes the instance from the global IntersectionObserver registry.
             * @private
             */
            IntersectionObserver.prototype._unregisterInstance = function () {
                var index = registry.indexOf(this);
                if (index != -1) registry.splice(index, 1);
            };

            /**
             * Returns the result of the performance.now() method or null in browsers
             * that don't support the API.
             * @return {number} The elapsed time since the page was requested.
             */
            function now() {
                return window.performance && performance.now && performance.now();
            }

            /**
             * Throttles a function and delays its execution, so it's only called at most
             * once within a given time period.
             * @param {Function} fn The function to throttle.
             * @param {number} timeout The amount of time that must pass before the
             *     function can be called again.
             * @return {Function} The throttled function.
             */
            function throttle(fn, timeout) {
                var timer = null;
                return function () {
                    if (!timer) {
                        timer = setTimeout(function () {
                            fn();
                            timer = null;
                        }, timeout);
                    }
                };
            }

            /**
             * Adds an event handler to a DOM node ensuring cross-browser compatibility.
             * @param {Node} node The DOM node to add the event handler to.
             * @param {string} event The event name.
             * @param {Function} fn The event handler to add.
             * @param {boolean} opt_useCapture Optionally adds the even to the capture
             *     phase. Note: this only works in modern browsers.
             */
            function addEvent(node, event, fn, opt_useCapture) {
                if (typeof node.addEventListener == 'function') {
                    node.addEventListener(event, fn, opt_useCapture || false);
                } else if (typeof node.attachEvent == 'function') {
                    node.attachEvent('on' + event, fn);
                }
            }

            /**
             * Removes a previously added event handler from a DOM node.
             * @param {Node} node The DOM node to remove the event handler from.
             * @param {string} event The event name.
             * @param {Function} fn The event handler to remove.
             * @param {boolean} opt_useCapture If the event handler was added with this
             *     flag set to true, it should be set to true here in order to remove it.
             */
            function removeEvent(node, event, fn, opt_useCapture) {
                if (typeof node.removeEventListener == 'function') {
                    node.removeEventListener(event, fn, opt_useCapture || false);
                } else if (typeof node.detatchEvent == 'function') {
                    node.detatchEvent('on' + event, fn);
                }
            }

            /**
             * Returns the intersection between two rect objects.
             * @param {Object} rect1 The first rect.
             * @param {Object} rect2 The second rect.
             * @return {?Object|?ClientRect} The intersection rect or undefined if no
             *     intersection is found.
             */
            function computeRectIntersection(rect1, rect2) {
                var top = Math.max(rect1.top, rect2.top);
                var bottom = Math.min(rect1.bottom, rect2.bottom);
                var left = Math.max(rect1.left, rect2.left);
                var right = Math.min(rect1.right, rect2.right);
                var width = right - left;
                var height = bottom - top;

                return width >= 0 && height >= 0 && {
                    top: top,
                    bottom: bottom,
                    left: left,
                    right: right,
                    width: width,
                    height: height
                } || null;
            }

            /**
             * Shims the native getBoundingClientRect for compatibility with older IE.
             * @param {Element} el The element whose bounding rect to get.
             * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
             */
            function getBoundingClientRect(el) {
                var rect;

                try {
                    rect = el.getBoundingClientRect();
                } catch (err) {
                    // Ignore Windows 7 IE11 "Unspecified error"
                    // https://github.com/w3c/IntersectionObserver/pull/205
                }

                if (!rect) return getEmptyRect();

                // Older IE
                if (!(rect.width && rect.height)) {
                    rect = {
                        top: rect.top,
                        right: rect.right,
                        bottom: rect.bottom,
                        left: rect.left,
                        width: rect.right - rect.left,
                        height: rect.bottom - rect.top
                    };
                }
                return rect;
            }

            /**
             * Returns an empty rect object. An empty rect is returned when an element
             * is not in the DOM.
             * @return {ClientRect} The empty rect.
             */
            function getEmptyRect() {
                return {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: 0,
                    height: 0
                };
            }

            /**
             * Ensure that the result has all of the necessary fields of the DOMRect.
             * Specifically this ensures that `x` and `y` fields are set.
             *
             * @param {?DOMRect|?ClientRect} rect
             * @return {?DOMRect}
             */
            function ensureDOMRect(rect) {
                // A `DOMRect` object has `x` and `y` fields.
                if (!rect || 'x' in rect) {
                    return rect;
                }
                // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
                // for internally calculated Rect objects. For the purposes of
                // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
                // for these fields.
                return {
                    top: rect.top,
                    y: rect.top,
                    bottom: rect.bottom,
                    left: rect.left,
                    x: rect.left,
                    right: rect.right,
                    width: rect.width,
                    height: rect.height
                };
            }

            /**
             * Inverts the intersection and bounding rect from the parent (frame) BCR to
             * the local BCR space.
             * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
             * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
             * @return {ClientRect} The local root bounding rect for the parent's children.
             */
            function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
                var top = parentIntersectionRect.top - parentBoundingRect.top;
                var left = parentIntersectionRect.left - parentBoundingRect.left;
                return {
                    top: top,
                    left: left,
                    height: parentIntersectionRect.height,
                    width: parentIntersectionRect.width,
                    bottom: top + parentIntersectionRect.height,
                    right: left + parentIntersectionRect.width
                };
            }

            /**
             * Checks to see if a parent element contains a child element (including inside
             * shadow DOM).
             * @param {Node} parent The parent element.
             * @param {Node} child The child element.
             * @return {boolean} True if the parent node contains the child node.
             */
            function containsDeep(parent, child) {
                var node = child;
                while (node) {
                    if (node == parent) return true;

                    node = getParentNode(node);
                }
                return false;
            }

            /**
             * Gets the parent node of an element or its host element if the parent node
             * is a shadow root.
             * @param {Node} node The node whose parent to get.
             * @return {Node|null} The parent node or null if no parent exists.
             */
            function getParentNode(node) {
                var parent = node.parentNode;

                if (node.nodeType == /* DOCUMENT */9 && node != document) {
                    // If this node is a document node, look for the embedding frame.
                    return getFrameElement(node);
                }

                // If the parent has element that is assigned through shadow root slot
                if (parent && parent.assignedSlot) {
                    parent = parent.assignedSlot.parentNode;
                }

                if (parent && parent.nodeType == 11 && parent.host) {
                    // If the parent is a shadow root, return the host element.
                    return parent.host;
                }

                return parent;
            }

            /**
             * Returns true if `node` is a Document.
             * @param {!Node} node
             * @returns {boolean}
             */
            function isDoc(node) {
                return node && node.nodeType === 9;
            }

            // Exposes the constructors globally.
            window.IntersectionObserver = IntersectionObserver;
            window.IntersectionObserverEntry = IntersectionObserverEntry;
        })();
    }, {}], 2: [function (require, module, exports) {
        require('intersection-observer/intersection-observer');
        IntersectionObserver.THROTTLE_TIMEOUT = 100;
        IntersectionObserver.USE_MUTATION_OBSERVER = true;

        if (window.NodeList && !NodeList.prototype.forEach) {
            // TOO many error events from browsers that is not supported by us
            // Аdd polyfill while sentry is enabled for them
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        if (!$.fn.scrollParent) {
            // jquery-ui scrollParent fn
            $.fn.scrollParent = function (includeHidden) {
                var position = this.css('position'),
                    excludeStaticParent = position === 'absolute',
                    overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
                    scrollParent = this.parents().filter(function () {
                    var parent = $(this);
                    if (excludeStaticParent && parent.css('position') === 'static') {
                        return false;
                    }
                    return overflowRegex.test(parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x'));
                }).eq(0);

                return position === 'fixed' || !scrollParent.length ? $(this[0].ownerDocument || document) : scrollParent;
            };
        }

        // source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
        // https://developer.mozilla.org/ru/docs/Web/API/ParentNode/append
        (function (arr) {
            arr.forEach(function (item) {
                if (item.hasOwnProperty('append')) {
                    return;
                }
                Object.defineProperty(item, 'append', {
                    configurable: true,
                    enumerable: true,
                    writable: true,
                    value: function append() {
                        var argArr = Array.prototype.slice.call(arguments),
                            docFrag = document.createDocumentFragment();

                        argArr.forEach(function (argItem) {
                            var isNode = argItem instanceof Node;
                            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                        });

                        this.appendChild(docFrag);
                    }
                });
            });
        })([Element.prototype, Document.prototype, DocumentFragment.prototype]);
    }, { "intersection-observer/intersection-observer": 1 }] }, {}, [2]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /*sockets realTime*/
        window.c_act_user_id = '';
        var callbacks = window.callbacks = {};
        var funcs = window.funcs = {};

        var siteId = 0;
        function randId() {
            return new Date().getTime() + Math.random();
        }

        //вызовы, запрошенные до события login
        var rt = window.rt = {
            connected: false,
            delayed_actions: [],
            afterLogin: {},
            afterClose: {},
            bind: function bind(route, callback) {
                if (route in funcs) {
                    funcs[route].push(callback);
                } else {
                    funcs[route] = [callback];
                }
                return rt;
            },
            trigger: function trigger(route, data) {
                if (route in funcs) {
                    for (var i = 0; i < funcs[route].length; i++) {
                        if (typeof funcs[route][i] === 'function') {
                            funcs[route][i](data);
                        }
                    }
                }
            },
            isOnline: function isOnline() {
                return rt.sock && rt.sock.readyState == 1;
            },

            /**
             * Пере подключение к websocket
             * На текущий момент другой возможности сделать это нет
             */
            reconnect: function reconnect() {
                if (rt.sock && rt.connected) {
                    console.info('manual ws reconnect');
                    // Подключение восстановится автоматически через N секунд
                    rt.sock.close();
                }
            }
        };

        var rtInit = window.rtInit = function () {
            var app = window.app;
            var sockUrl = app.sock.main;
            if (location.hash === '#local' || document.cookie.indexOf('local_ws') !== -1 || document.cookie.indexOf('ws_local') !== -1) {
                sockUrl = app.sock.local;
            }

            app.sock.current = sockUrl;
            rt.sock = new SockJS(app.sock.current, null, {
                transports: 'websocket'
            });

            rt.isLogin = false;
            rt.timer = false;
            rt.go = function (route, data, callback) {
                if (!rt.connected) {
                    rt.delayed_actions.push({
                        route: route,
                        data: data,
                        callback: callback
                    });
                } else {
                    var res = route.split('.');
                    if (callback) {
                        var callbackId = 'callback_' + randId();
                        if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object') {
                            data.clientCallbackId = callbackId;
                        }
                        if (!callbacks[route]) {
                            callbacks[route] = {};
                        }
                        callbacks[route][callbackId] = callback;
                        callbacks[route].lastCallback = callback;
                    }
                    rt.sock.send(JSON.stringify({
                        c: res[0],
                        a: res[1],
                        d: data
                    }));
                }

                return rt;
            };

            rt.sock.onopen = function () {
                rt.connected = true;
                // var now = new Date();
                // console.log('open : ' + now.toString());
                rt.go('app.login', {
                    id: app.id,
                    key: app.key,
                    nid: app.nid,
                    nkey: app.nkey,
                    ukey: app.ukey,
                    bkey: app.bkey,
                    opToken: app.opToken,
                    site: siteId,
                    cur: app.currency,
                    loginParams: '',
                    isMobile: app.isMobile,
                    location: window.location.href,
                    yandexClientId: app.yandex_client_id
                }, function (data) {
                    // var now = new Date();
                    // console.log('login : ' + now.toString());
                    if (data.success) {
                        rt.isLogin = true;
                    }
                    var i = void 0;
                    for (i in rt.afterLogin) {
                        rt.afterLogin[i](data);
                    }
                    if (rt.delayed_actions.length) {
                        for (i = 0; i < rt.delayed_actions.length; i++) {
                            rt.go(rt.delayed_actions[i]['route'], rt.delayed_actions[i]['data'], rt.delayed_actions[i]['callback']);
                        }
                        rt.delayed_actions = [];
                    }
                });
            };

            rt.sock.onmessage = function (e) {
                var data = JSON.parse(e.data);
                if (callbacks[data.r]) {
                    if (data.d && data.d.clientCallbackId) {
                        if (typeof callbacks[data.r][data.d.clientCallbackId] === 'function') {
                            callbacks[data.r][data.d.clientCallbackId](data.d);
                        }
                        delete callbacks[data.r][data.d.clientCallbackId];
                    } else {
                        if (typeof callbacks[data.r].lastCallback === 'function') {
                            callbacks[data.r].lastCallback(data.d);
                        }
                        delete callbacks[data.r];
                    }
                }
                rt.trigger(data.r, data.d ? data.d : {});
            };

            rt.sock.onerror = function (e) {
                console.error(e);
            };

            rt.sock.onclose = function (e) {
                console.error(e);
                rt.connected = false;
                for (var i in rt.afterClose) {
                    rt.afterClose[i]();
                }
                clearTimeout(rt.timer);
                // чтобы показать что поиск завершился и при пере открытии соединения можно было
                // начать новый
                if (window.search) {
                    search.progress = 100;
                }
                rt.timer = setTimeout(rtInit, 3000);
            };

            rt.sock.onheartbeat = function () {
                //console.log('heartbeat');
            };
        };
        $(function () {
            rtInit();
        });

        rt.afterLogin['todo.join'] = function (data) {
            if (data.isManager) {
                rt.go('chans.join', { id: 'notify' });
            }
        };
        rt.bind('notify.mess', function (data) {
            if (data) {
                console.log(data);
            }
        });
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var statLog = [];

        var PIXEL_EVENT_LEAD = 'Lead';
        var PIXEL_EVENT_INITIATE_CHECKOUT = 'InitiateCheckout';
        var PIXEL_EVENT_VIEW_CONTENT = 'ViewContent';
        var PIXEL_EVENT_COMPLETE_REGISTRATION = 'CompleteRegistration';

        function isTrackingEnabled() {
            return !window.app.isWorker;
        }

        var isLogEnabled = function isLogEnabled() {
            return window.app && !window.app.isWorker;
        };

        // храним отложенные события, пока не загрузились все скрипты
        window.pendingRoistatAnalyticEvents = [];
        window.pendingAmplitudeAnalyticEvents = [];

        function consoleLog() {
            if (isLogEnabled()) {
                var _console;

                (_console = console).log.apply(_console, arguments);
            }
        }

        var isPixelInitialized = false;
        window.brxTracking = {
            log: function log() {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                console.log(args);
            },
            sendRoistatAnalyticsEvent: function sendRoistatAnalyticsEvent(eventName) {
                if (window.roistat) {
                    consoleLog('sendAnalyticsEvent: ' + eventName);
                    window.roistat.event.send(eventName);
                } else {
                    window.pendingRoistatAnalyticEvents.push(eventName);
                    consoleLog('sendAnalyticsEvent: roistat not exist, pending', eventName);
                }
            },
            sendAmplitudeAnalyticsEvent: function sendAmplitudeAnalyticsEvent(eventName) {
                var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                eventProperties['Site platform'] = window.app.isMobile ? 'Mobile' : 'Desktop';
                eventProperties['Platform type'] = window.app.platform;
                eventProperties['Page type'] = 'metrikaPageType' in window.app.pageParams ? window.app.pageParams.metrikaPageType : null;
                eventProperties['Page country id'] = 'page_country_id' in window.app.pageParams ? window.app.pageParams.page_country_id : null;
                eventProperties['Is auth'] = 'isClientAuth' in window.app ? window.app.isClientAuth : null;
                eventProperties['AB test list'] = 'abTestList' in window.app ? window.app.abTestList : [];
                eventProperties['City id'] = 'city' in window.app ? window.app.city.name : null;
                if (window.amplitude) {
                    consoleLog('sendAmplitudeAnalyticsEvent: ' + eventName, eventProperties);
                    window.amplitude.track(eventName, eventProperties);
                } else {
                    window.pendingAmplitudeAnalyticEvents.push({ eventName: eventName, eventProperties: eventProperties });
                    consoleLog('sendAnalyticsEvent: amplitude not exist, pending', eventName, eventProperties);
                }
            },

            sendAnalyticsEvent: function sendAnalyticsEvent(eventName) {
                var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                if (app.login !== 'guest') {
                    // не отслеживаем события для сотрудников компании
                    return;
                }
                window.brxTracking.sendAmplitudeAnalyticsEvent(eventName, eventProperties);
                // отправляем в google analytics
                if (window.gtag) {
                    window.gtag('event', eventName, eventProperties);
                }
            },
            /**
             * @param {string} eventName
             */
            setEvent: function setEvent(eventName) {
                this.setYaEvent(eventName);
                if (eventName.indexOf('.') !== -1) {
                    var eventParams = eventName.split('.');
                    this.setGAEvent(eventParams[0], eventParams[1]);
                }
            },
            setGAEvent: function setGAEvent(eventCategory, eventAction) {
                var params = { eventCategory: eventCategory, eventAction: eventAction };
                consoleLog('setGAEvent:', params);
                if (isTrackingEnabled()) {
                    if (typeof window.dataLayer !== 'undefined') {
                        // На сайте установлен GTM
                        window.dataLayer.push({ event: eventCategory + "." + eventAction });
                    } else if (typeof window.ga !== 'undefined') {
                        window.ga('send', 'event', params);
                    }
                }
            },
            setYaEvent: function setYaEvent(name) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                consoleLog('setYaEvent: ', name, params);
                if (typeof window.yaCounter16190941 !== 'undefined' && isTrackingEnabled()) {
                    window.yaCounter16190941.reachGoal(name, params);
                }
            },

            /**
             * Отслеживание событий в pixel (facebook)
             * @see window.brxTracking.pixel
             * @param {string} event
             */
            setPixelEvent: function setPixelEvent(event) {
                if (typeof window.fbq === 'function') {
                    fbq('track', event);
                }
            },
            stat: function stat(type, params) {
                var isDisabled = app && app.debug === 1;
                var app = window.app;

                // если тут ставить window.top.location.href, то падает вебвизор из-за CORS
                var data = {
                    ukey: app.ukey,
                    cityId: app.city && app.city.id ? app.city.id : null,
                    realCityId: app.realCity && app.realCity.id ? app.realCity.id : null,
                    srcId: app.src_id,
                    type: type,
                    href: window.location.href,
                    isFrame: window != window.top,
                    params: params
                };

                if (isDisabled) {
                    console.log('stat localhost: ', data);
                    return;
                }

                var rt = window.rt;
                if (rt.isOnline()) {
                    rt.go('stat.save', data);
                } else {
                    statLog.push(data);
                    rt.afterLogin['saveStatLog'] = function () {
                        if (statLog.length) {
                            rt.go('stat.save', statLog);
                            statLog = [];
                        }
                        delete rt.afterLogin['saveStatLog'];
                    };
                }
            },
            statCurrency: function statCurrency(currency) {
                this.stat(14, { info: currency });
            },

            /**
             * @param {number} cityId
             */
            updateSourceVisit: function updateSourceVisit(cityId) {
                var srcId = null;
                var app = window.app;
                if (app.updateSourceId !== undefined) {
                    srcId = app.updateSourceId;
                } else if (!document.referrer) {
                    srcId = 33; // прямой вход
                }
                if (srcId !== null) {
                    $.get('/site/updateCounter', {
                        src_id: srcId,
                        city_id: cityId
                    });
                }
            },
            initFaceBookPixel: function initFaceBookPixel(cityId) {
                if (!isTrackingEnabled() || isPixelInitialized) {
                    return;
                }
                isPixelInitialized = true;

                var pixelId = null;
                switch (cityId) {
                    case 3:
                        // Алматы
                        pixelId = '856421511127540';
                        break;
                    case 1:
                        // Астана
                        pixelId = '212197272519320';
                        break;
                    case 4:
                        // Караганда
                        pixelId = '362775650890207';
                        break;
                    case 22:
                        // Шымкент
                        pixelId = '386868035110715';
                        break;
                }
                if (pixelId !== null) {
                    !function (f, b, e, v, n, t, s) {
                        if (f.fbq) return;
                        n = f.fbq = function () {
                            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                        };
                        if (!f._fbq) f._fbq = n;
                        n.push = n;
                        n.loaded = !0;
                        n.version = '2.0';
                        n.queue = [];
                        t = b.createElement(e);
                        t.async = !0;
                        t.src = v;
                        s = b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t, s);
                    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', pixelId); // Insert your pixel ID here.
                    fbq('track', 'PageView');
                }
            },

            callTrackingRefresh: function callTrackingRefresh() {
                consoleLog('callTrackingRefresh');
                if (window.roistatCallTrackingRefresh) {
                    window.roistatCallTrackingRefresh();
                }
                window.brxTracking.refreshWhatsAppLink();
                window.brxTracking.refreshAppLink();
                if (typeof jivo_api !== 'undefined' && 'roistatGetCookie' in window) {
                    jivo_api.setCustomData([{
                        "content": "Номер визита: " + window.roistatGetCookie('roistat_visit')
                    }]);
                    console.log("Номер визита: " + window.roistatGetCookie('roistat_visit'));
                }
                // ройстата иногда нет, так как блокируется ads block
                window.brxTracking.setRoistatVisitDeviceId();
            },
            /**
             * Сохраняем параметры визита только через этот метод, чтобы не перезаписывать используемые параметры
             * Так как собственные переменные давать нельзя,
             * то используем roistat_param2, roistat_param3, roistat_param4
             */
            setRoistatVisitDeviceId: function setRoistatVisitDeviceId() {
                if (typeof window.amplitude !== 'undefined' && typeof window.amplitude.getDeviceId() !== 'undefined' && window.roistat) {
                    var params = {
                        roistat_param2: window.amplitude.getDeviceId(),
                        roistat_param3: window.brxUserActivity ? window.brxUserActivity.getVUid() : ''
                    };
                    if (window.ymVisitParams && window.ymVisitParams.pageType) {
                        params.roistat_param1 = window.ymVisitParams.pageType;
                    }
                    // Нужен для отслеживания оффлайн конверсий ga4
                    var urlParams = new URLSearchParams(window.location.search);
                    var googleClickId = urlParams.get('gclid');
                    if (googleClickId) {
                        params.roistat_param4 = googleClickId;
                    }
                    window.roistat.setRoistatParams(params);
                }
            },

            processRoistatAnalyticEvents: function processRoistatAnalyticEvents() {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = window.pendingRoistatAnalyticEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var eventName = _step.value;

                        consoleLog('Send roistat pending event: ' + eventName);
                        window.brxTracking.sendRoistatAnalyticsEvent(eventName);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                window.pendingRoistatAnalyticEvents = [];
            },
            processAmplitudeAnalyticEvents: function processAmplitudeAnalyticEvents() {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = window.pendingAmplitudeAnalyticEvents[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var event = _step2.value;

                        consoleLog('Send amplitude pending event: ' + event);
                        window.brxTracking.sendAmplitudeAnalyticsEvent(event.eventName, event.eventProperties);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                window.pendingAmplitudeAnalyticEvents = [];
            },
            refreshWhatsAppLink: function refreshWhatsAppLink() {
                if ('roistatGetCookie' in window) {
                    var message = 'Здравствуйте! Пишу с сайта ht.kz, номер визита: {roistat_visit} \n--------------\nМой вопрос: ';
                    var text = message.replace(/{roistat_visit}/g, window.roistatGetCookie('roistat_visit'));
                    text = encodeURI(text);
                    var linkElements = document.querySelectorAll('[href*="//wa.me/"], [href*="//web.whatsapp.com"], [data-whatsapplink]');
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = linkElements[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var element = _step3.value;

                            var url = element.href || element.dataset.whatsapplink;
                            var param = 'text';
                            var value = text;
                            var explodedUrl = url.split('?');
                            var baseUrl = explodedUrl[0] || '';
                            var query = '?' + (explodedUrl[1] || '');
                            var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
                            var queryWithoutParameter = query.replace(regex, "$1").replace(/&$/, '');
                            var newUrl = baseUrl + (queryWithoutParameter.length > 2 ? queryWithoutParameter + '&' : '?') + (value ? param + "=" + value : '');
                            if (element.href) {
                                element.href = newUrl;
                            } else {
                                element.dataset.whatsapplink = newUrl;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    console.log(linkElements);
                } else {
                    consoleLog('refreshWhatsAppLink FAILED: roistatGetCookie not exist');
                }
            },
            pixel: {
                LEAD: PIXEL_EVENT_LEAD,
                INITIATE_CHECKOUT: PIXEL_EVENT_INITIATE_CHECKOUT,
                VIEW_CONTENT: PIXEL_EVENT_VIEW_CONTENT,
                COMPLETE_REGISTRATION: PIXEL_EVENT_COMPLETE_REGISTRATION
            },
            refreshAppLink: function refreshAppLink() {
                var sessionClickURL = sessionStorage.getItem('clickURL');
                if (sessionClickURL) {
                    var appLinkElements = document.querySelectorAll('[href*="//htkz.onelink.me/KEGi/menu"]');
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = appLinkElements[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var element = _step4.value;

                            element.href = sessionClickURL;
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
            },
            updateSmartScript: function updateSmartScript() {
                if (typeof AF_SMART_SCRIPT_RESULT === 'undefined') {
                    return;
                }
                var smartScriptVar = AF_SMART_SCRIPT_RESULT;
                var sessionClickURL = sessionStorage.getItem('clickURL');
                if (!sessionClickURL && smartScriptVar !== undefined && smartScriptVar.clickURL !== undefined) {
                    sessionStorage.setItem('clickURL', smartScriptVar.clickURL);
                }
            }
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // const app = window.app; // Нельзя добавить alias в desktop
        // const rt = window.rt; // TODO: define after desktop check

        window.brxUserActivity = {
            getVUid: function getVUid() {
                return app.v_uid;
            },
            isEnabled: function isEnabled() {
                return app && app.ip !== '127.0.0.1' && app.debug === 0;
            },
            isNeedGenerateVUid: function isNeedGenerateVUid() {
                return app && app.ip !== '127.0.0.1' && (app.login === 'guest' || !app.isWorker);
            },
            generateVUid: function generateVUid() {
                if (app.v_uid) {
                    window.brxUserActivity.setVUid(app.v_uid); // extend ttl
                } else {
                    var history = window.brxUserActivity.getUserHistory();
                    window.rt.go('app.getVUid', { history: history }, function (vUid) {
                        window.brxUserActivity.setVUid(vUid);
                    });
                }
            },

            /**
             * @param {string} vUid
             */
            setVUid: function setVUid(vUid) {
                app.v_uid = vUid;
                window.brxUtils.cookies.set('v_uid', vUid, {
                    expires: 5 * 365 * 24 * 60 * 60, // 5 years in seconds
                    path: '/'
                });
            },
            getUserHistory: function getUserHistory() {
                if (!window.brxUtils.isLocalStorageSupported) {
                    return {};
                }
                // парсим значение в localStorage
                var historyValue = window.localStorage.getItem('userHistory');
                var historyObj = [];
                if (historyValue !== null) {
                    historyObj = JSON.parse(historyValue);
                }
                try {
                    // выкидываем слишком старые записи
                    // храним последние 300 действий
                    return historyObj.slice(0, 299);
                } catch (e) {
                    // если historyObj не массив, а объект, обнуляем историю действий
                    historyObj = [];
                    window.localStorage.setItem('userHistory', JSON.stringify(historyObj));

                    return historyObj;
                }
            },

            /**
             * @param data
             * @return {boolean}
             */
            updateUserHistory: function updateUserHistory(data) {
                if (!window.brxUserActivity.isEnabled()) {
                    console.info('action save disabled. Action "%s" skipped', data.type);
                    return false;
                }
                var item = {
                    type: data.type,
                    url: data.hasOwnProperty('url') ? data.url : '',
                    desc: data.hasOwnProperty('desc') ? data.desc : '',
                    item_id: data.hasOwnProperty('item_id') ? data.item_id : null,
                    ip: app.ip || '',
                    time: new Date().getTime()
                };

                // если v_uid уже есть, то сохраняем действия
                if (app.v_uid && !app.isWorker && window.rt && rt.go) {
                    item.v_uid = app.v_uid;
                    rt.go('app.save_user_activity', item);
                } else {
                    if (!window.brxUtils.isLocalStorageSupported) {
                        return false;
                    }
                    var historyObj = window.brxUserActivity.getUserHistory();
                    // добавляем новый элемент
                    var newHistory = [item];
                    newHistory = newHistory.concat(historyObj);
                    window.localStorage.setItem('userHistory', JSON.stringify(newHistory));
                }

                return true;
            },

            /**
             * Посещение текущей страницы
             * Вызов функции может быть зарегистрирован на backend
             */
            saveVisit: function saveVisit() {
                this.savePageVisit(location.href, document.title);
            },

            /**
             * Зафиксировать посещение страницы
             * (e.g. Продающая. в href появляется дата, но title не меняется)
             * @param {string} href
             * @param {string} desc
             */
            savePageVisit: function savePageVisit(href, desc) {
                saveUserActivityAction('page', href, desc);
            },

            /**
             * Просмотр отеля
             * Вызов функции может быть зарегистрирован на backend
             * @param {string} href
             * @param {string} desc
             */
            saveHotelView: function saveHotelView(href, desc) {
                saveUserActivityAction('hotel', href, desc);
            },

            /**
             * Поиск туров
             * @param {string} href - ссылка на поиск
             * @param {string} desc - описание параметров поиска
             */
            saveSearch: function saveSearch(href, desc) {
                saveUserActivityAction('search', href, desc);
            }
        };

        /**
         * Не прокидывайте глобально, доступно только в текущем файле
         * @param {string} category
         * @param {string} href
         * @param {string} desc
         */
        function saveUserActivityAction(category, href, desc) {
            if (!window.brxUserActivity.isEnabled()) {
                console.info('action save disabled. Action "%s" skipped', category);
                return;
            }
            if (href.indexOf('http') !== 0) {
                href = location.origin + href;
            }
            window.brxUserActivity.updateUserHistory({
                type: category,
                url: href,
                desc: desc
            });
        }
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var toursShortIdStorage = {};

        /**
         * helper for i18n js messages
         */

        var I18nMessages = function () {
            function I18nMessages() {
                _classCallCheck(this, I18nMessages);
            }

            _createClass(I18nMessages, null, [{
                key: "template",

                /**
                 * @param {string} message
                 * @param {{}} params
                 * @return {string}
                 */
                value: function template(message, params) {
                    for (var key in params) {
                        if (params.hasOwnProperty(key)) {
                            message = message.split('{' + key + '}').join(params[key]);
                        }
                    }

                    return message.replace(/{([^}]+)}/g, '$1');
                }

                /**
                 * @param {number} number
                 * @param {[string, string, string]} pluralMessage
                 */

            }, {
                key: "plural",
                value: function plural(number, pluralMessage) {
                    var _window$brxUtils;

                    return (_window$brxUtils = window.brxUtils).getnoun.apply(_window$brxUtils, [number].concat(_toConsumableArray(pluralMessage)));
                }
            }]);

            return I18nMessages;
        }();

        window.brxUtils = {
            i18n: I18nMessages,
            /**
             * @param {*} data
             * @return {boolean}
             */
            isObject: function isObject(data) {
                return (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' && data !== null;
            },
            /**
             * см ShareData
             * @param {{
             *   text?: string;
             *   title: string;
             *   url?: string;
             *   files?: File[];
             * }} data
             * @param messageOnSuccessCopy
             */
            share: function share(data) {
                var messageOnSuccessCopy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                var shareData = {
                    title: data.title
                };
                if (data.url) {
                    shareData.url = data.url;
                }
                if (data.text) {
                    shareData.text = data.text;
                }

                if (navigator.share) {
                    navigator.share(shareData).catch(function (error) {
                        console.log('Error sharing:', error);
                        var copyText = shareData.url || data.text;
                        window.brxUtils.copyToClipBoard(copyText, messageOnSuccessCopy);
                    });
                } else {
                    var copyText = shareData.url || data.text;
                    window.brxUtils.copyToClipBoard(copyText, messageOnSuccessCopy);
                }
            },
            /**
             * @param {string} text
             * @param {string|null} messageOnSuccess
             */
            copyToClipBoard: function copyToClipBoard(text) {
                var messageOnSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                var bufferField = document.createElement('textarea');
                document.body.appendChild(bufferField);
                bufferField.value = text;
                bufferField.select();
                document.execCommand('copy');
                document.body.removeChild(bufferField);
                // eslint-disable-next-line no-alert
                window.alert(messageOnSuccess || 'Ссылка скопирована в буфер обмена.');
            },
            /**
             * @type {boolean}
             */
            isLocalStorageSupported: function () {
                try {
                    if (!('localStorage' in window)) {
                        return false;
                    }
                    if (_typeof(window.localStorage) !== 'object') {
                        return false;
                    }

                    var testKey = 'test';
                    var storage = window.localStorage;
                    storage.setItem(testKey, '1');
                    storage.removeItem(testKey);
                    return true;
                } catch (error) {
                    return false;
                }
            }(),
            cookies: {
                /**
                 * Возвращает cookie с именем name, если есть, если нет, то undefined
                 * @param {string} name
                 * @return {any|undefined}
                 */
                get: function get(name) {
                    var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
                    return matches ? decodeURIComponent(matches[1]) : undefined;
                },

                /**
                 * options.expires in seconds
                 *
                 * @param {string} name
                 * @param {*} value
                 * @param {{
                 *  expires: number,
                 * }} options
                 */
                set: function set(name, value, options) {
                    options = options || {};

                    var expires = options.expires; // seconds
                    if (typeof expires === 'number' && expires) {
                        var d = new Date();
                        d.setTime(d.getTime() + expires * 1000);
                        expires = options.expires = d;
                    }
                    if (expires && expires.toUTCString) {
                        options.expires = expires.toUTCString();
                    }

                    value = encodeURIComponent(value);

                    var updatedCookie = name + '=' + value;

                    for (var propName in options) {
                        updatedCookie += '; ' + propName;
                        var propValue = options[propName];
                        if (propValue !== true) {
                            updatedCookie += '=' + propValue;
                        }
                    }

                    document.cookie = updatedCookie;
                }
            },
            /**
             * @param {number} number
             * @param {string} one
             * @param {string} two
             * @param {string} five
             * @param {string|null} glue
             * @return {string}
             */
            getnoun: function getnoun(number, one, two, five) {
                var glue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

                number = Math.abs(number);
                number = number % 100;
                glue = glue ? '' + number + ' ' : '';
                if (number >= 5 && number <= 20) {
                    return glue + five;
                }

                number = number % 10;
                if (number === 1) {
                    return glue + one;
                }

                if (number >= 2 && number <= 4) {
                    return glue + two;
                }

                return glue + five;
            },
            nf: function nf(value) {
                var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&nbsp;';

                return ('' + value).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
            },
            nfm: function nfm(value, min) {
                if (!min) {
                    min = 10000;
                }
                return Number(value) >= min ? window.brxUtils.nf(value) : value;
            },
            isElementInPopup: function isElementInPopup($el) {
                return !!$el.closest(app.isMobile ? '.mpopup' : '.modal').length;
            },
            scrollToElement: function scrollToElement($el, deltaTop) {
                var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;

                if ($el.length) {
                    var inPopup = window.brxUtils.isElementInPopup($el);
                    var scrollTop = void 0;
                    var $scrollParent = void 0;
                    if (!inPopup) {
                        $scrollParent = $('html, body');
                        scrollTop = $el.offset().top;
                    } else {
                        $scrollParent = $el.scrollParent();
                        scrollTop = $scrollParent.scrollTop() - $scrollParent.offset().top + $el.offset().top;
                    }
                    $scrollParent.animate({ scrollTop: scrollTop - (deltaTop || 0) }, duration);
                }
            },

            /**
             * @param {Function} callback
             * @param {number} wait
             * @return {Function}
             */
            debounce: function debounce(callback, wait) {
                var timeout = void 0;
                return function () {
                    var context = this,
                        args = arguments;
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        timeout = null;
                        callback.apply(context, args);
                    }, wait);
                    return true;
                };
            },

            /**
             * @param {Function} callback
             * @param {number} wait
             * @return {Function}
             */
            throttle: function throttle(callback, wait) {
                var lastCallTime = Date.now();
                return function () {
                    if (lastCallTime + wait - Date.now() < 0) {
                        callback.apply(this, arguments);
                        lastCallTime = Date.now();
                    }
                    return true;
                };
            },

            /**
             * @param {string} realId
             * @param {string|jQuery} selector - куда вставить результат (object == jquery object)
             * @param {Function} [callback]
             */
            getShortTourId: function getShortTourId(realId, selector) {
                var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                var $elems = $(selector);
                if ($elems.length) {
                    var processResult = function processResult(shortId) {
                        $elems.html('#' + shortId);
                        if (typeof callback === 'function') {
                            callback('#' + shortId);
                        }
                    };

                    if (app && app.isWorker) {
                        processResult(realId);
                    } else {
                        if (toursShortIdStorage.hasOwnProperty(realId)) {
                            var shortId = toursShortIdStorage[realId];
                            processResult(shortId);
                        } else {
                            $elems.html('<img src="/img/load.gif" alt="" class="short-tour-id-loading">');
                            $.post('/tours/hotel/getShortId', { realId: realId }, function (shortId) {
                                toursShortIdStorage[realId] = shortId;
                                processResult(shortId);
                            }, 'json');
                        }
                    }
                } else {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                }
            }
        };
    }, {}] }, {}, [1]);